import { Button } from "@cofano/cck";
import GetAppIcon from "@mui/icons-material/GetApp";
import { SailingReportFromQuery, SailingReportsFilter } from "view/sailingreports/SailingReports";
import useDownloadSailingReport from "view/sailingreports/utils/useDownloadSailingReport";

const SailingReportDownloadButton = ({
	selection,
	isFullSelect,
	filter,
	onCompleted,
}: {
	selection: SailingReportFromQuery[];
	isFullSelect: boolean;
	filter: SailingReportsFilter;
	onCompleted: () => void;
}) => {
	const { loading, onDownload } = useDownloadSailingReport();

	return (
		<Button
			disabled={selection.length === 0 || loading}
			icon={<GetAppIcon fontSize="small" />}
			loading={loading}
			size="small"
			onClick={() => {
				const sailingReportIds = selection.map(it => it.id);
				onDownload(sailingReportIds, filter, isFullSelect).finally(() => onCompleted());
			}}
			variant="outlined" />
	);
};

export default SailingReportDownloadButton;
